import { TableColumn } from "../types/table-column";

export const buildingsColumns: TableColumn[] = [
    {
        type: 'address',
        value: 'building / nfc tag name',
        fieldName: 'name',
        width: 340
    },
    {
        type: 'location',
        value: 'address',
        fieldName: 'address',
        width: 300
    },
    {
        type: 'weekly-monthly',
        value: 'working hours',
        secondaryValue: 'week | month',
        fieldName: 'workingHours',
        width: 200
    },
    {
        type: 'weekly-monthly',
        value: 'tasks',
        secondaryValue: 'week | month',
        fieldName: 'tasksCount',
        width: 200
    },
    {
        type: 'weekly-monthly',
        value: 'number of employees',
        secondaryValue: 'week | month',
        fieldName: 'employeesCount',
        width: 200
    },
    {
        type: 'actions',
        value: '',
        fieldName: 'buildings',
        width: 50
    }
];

export const tasksColumns: TableColumn[] = [
    {
        type: 'date',
        value: 'date',
        fieldName: 'date',
        width: 150
    },
    {
        type: 'user',
        value: 'carried out by',
        fieldName: 'user',
        width: 180
    },
    {
        type: 'tasks',
        value: 'was done',
        fieldName: 'tasks',
        width: 650
    },
];

export const employeesColumns: TableColumn[] = [
    {
        type: 'user',
        value: 'staff_member',
        fieldName: 'user',
        width: 150
    },
    {
        type: 'activities-hours',
        value: 'hours-activities',
        secondaryValue: 'per month',
        fieldName: 'workingHours',
        width: 150
    },
    {
        type: 'average rating',
        value: 'average_rating',
        fieldName: 'rating',
        width: 180
    },
    {
        type: 'locations',
        value: 'locations',
        fieldName: 'locations',
        width: 500
    },
];